import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React from "react";
import IsicName from "../../assets/images/options/isicNameIcon";
import BlogIcon from "../../assets/images/options/blogIcon";
import HeadsetIcon from "../../assets/images/options/headsetIcon";
import ChatIcon from "../../assets/images/options/chatIcon";
import QuestionMark from "../../assets/images/options/questionMark";

const OptionsCard = () => {
  return (
    <View style={styles.root}>
      <View style={styles.item}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL("https://www.carteiradoestudante.com.br/sobre")
          }
          style={styles.iconBox}
        >
          <IsicName />
        </TouchableOpacity>
        <Text style={styles.itemText}>Quem somos</Text>
      </View>
      <View style={styles.item}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL("https://www.carteiradoestudante.com.br/blog")
          }
          style={styles.iconBox}
        >
          <BlogIcon />
        </TouchableOpacity>
        <Text style={styles.itemText}>Nosso blog</Text>
      </View>
      <View style={styles.item}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL("https://www.carteiradoestudante.com.br/duvidas")
          }
          style={styles.iconBox}
        >
          <ChatIcon style={styles.chatIcon} />
          <QuestionMark style={styles.questionMark} />
        </TouchableOpacity>
        <Text style={styles.itemText}>Dúvidas frequentes</Text>
      </View>
      <View style={styles.item}>
        <TouchableOpacity
          onPress={() =>
            Linking.openURL(
              "https://www.carteiradoestudante.com.br/fale-conosco"
            )
          }
          style={styles.iconBox}
        >
          <HeadsetIcon />
        </TouchableOpacity>
        <Text style={styles.itemText}>Entre em contato</Text>
      </View>
    </View>
  );
};

export default OptionsCard;

const styles = StyleSheet.create({
  root: {
    width: "90%",
    marginHorizontal: "5%",
    height: 138,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 17,
    marginBottom: 24,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 22,
  },
  item: {
    flex: 1,
    alignItems: "center",
  },
  iconBox: {
    width: 50,
    height: 50,
    borderRadius: 25,
    borderWidth: 1,
    borderColor: "#e1e8e8",
    alignItems: "center",
    justifyContent: "center",
  },
  itemText: {
    textAlign: "center",
    fontSize: 12,
    lineHeight: 14,
    width: 62,
    marginTop: 8,
  },
  questionMark: {
    position: "absolute",
    left: 20,
    top: 16,
  },
  chatIcon: {
    width: 27,
    marginTop: 3,
  },
});
